
export default {
  name: 'Homepage',
  components: {},
  data() {
    return {
      activeIndex: '1',
      isB: true,
      isC: false,
      switchBthText: 'Job seeker',
      isHome: true,
      isHomepage: true,
      isDownload: false,
      isRecruiters: true,
      downloadUrlApple: 'https://hireyapp.onelink.me/7R9y/xgxetvna',
      downloadUrlGoogle: 'https://hireyapp.onelink.me/7R9y/swv5jwsa',
      teamLogos: [
        {
          src: require('@/assets/img/logo_ziprecruiter.png'),
          width:"auto",
          height:"55px",
        },
        {
          src: require('@/assets/img/logo_linkedin.png'),
          width:"auto",
          height:"40px",
        },
        {
          src: require('@/assets/img/logo_asu.png'),
          width:"auto",
          height:"55px",
        },
      ],
      userLogos: [
        {
          src: require('@/assets/img/logo_kw.png'),
          width:"auto",
          height:"60px",
        },
        {
          src: require('@/assets/img/logo_google.png'),
          width:"auto",
          height:"45px",
        },
        {
          src: require('@/assets/img/logo_synergy.png'),
          width:"auto",
          height:"45px",
        },
        {
          src: require('@/assets/img/logo_marriott.png'),
          width:"auto",
          height:"50px",
        },
        {
          src: require('@/assets/img/logo_gc.png'),
          width:"auto",
          height:"45px",
        },
      ]
    }
  },
  mounted() {
    this.loadTrustPilotScript()
    if (window.location.href.indexOf('/jobSeeker') > -1) {
      this.switchBthText = 'Recruiter'
    } else {
      this.switchBthText = 'Job seeker'
    }
    if (window.location.href.indexOf('/download') > -1) {
      this.pageBthDownload()
    }
    window.addEventListener('popstate', this.popstate, false)
  },
  destroyed() {
    window.removeEventListener('popstate', this.popstate, false)
  },
  methods: {
    switchBth() {
      if (window.location.href.indexOf('/jobSeeker') > -1) {
        this.switchBthText = 'Job seeker'
        this.$router.push('/recruiter')
      } else {
        this.switchBthText = 'Recruiter'
        this.$router.push('/jobseeker')
      }
      console.log(window.location.href.indexOf('/recruiter'))
    },
    pageBthHomepage() {
      this.isHome = true
      // this.$router.push('/recruiter')
      this.isHomepage = true
      this.isDownload = false
      this.switchBthText = 'Job seeker'
    },
    pageBthDownload() {
      this.isHome = false
      this.$router.push('/download')
      this.isHomepage = false
      this.isDownload = true
      // this.$router.push('/download')
    },
    popstate() {
      if (window.location.href.indexOf('/download') > -1) {
        this.isHome = true
        this.isHomepage = true
      } else {
        this.isHome = true
        this.isHomepage = true
      }
      if (window.location.href.indexOf('/recruiter') > -1) {
        this.switchBthText = 'Job seeker'
      } else {
        this.switchBthText = 'Recruiter'
      }
    },
    roleChangeBth(role) {
      if (role === 'Recruiters') {
        this.isRecruiters = true
      } else {
        this.isRecruiters = false
      }
      console.log(role)
    },
    downloadBth(url) {
      window.open(url, '_blank')
      // if (url === this.downloadUrlApple) {
      //   console.log('apple')
      //   logSend('MC', 'e_re_website_appstore', {
      //       region_id: 1
      //   })
      // } else {
      //   console.log('google')
      //   logSend('MC', 'e_re_website_googleplay', {
      //       region_id: 1
      //   })
      // }
    },
    loadTrustPilotScript() {
      const script = document.createElement('script');
      script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.onload = () => {
        console.log('Trustpilot script loaded');
      };
      document.body.appendChild(script);
    }

  }

}
